import gql from 'graphql-tag';
export const INITIAL_QUERY = gql `
  query user {
    profile {
      userId
    }
  }
`;
